/**
 * `validateSearch` of `/admin/locations`: the organization filter travels in the URL, so the
 * "Ver"/"Agregar" link of the organization's own panel (`organizations.locationsSummary`,
 * `OrganizationsPage.tsx`) opens the grid already narrowed to it, the same idiom as
 * `requestsSearchSchema` and `auditLogSearchSchema`.
 */
export interface LocationsSearch {
  organizationId?: string;
}

export function locationsSearchSchema(search: Record<string, unknown>): LocationsSearch {
  const organizationId = search['organizationId'];
  return typeof organizationId === 'string' && organizationId.length > 0 ? { organizationId } : {};
}
